export function createCol(header: string, accessor: string, options: any = null) {
	return { header: header, accessor: accessor, ...options }
}
